import { Checkbox, FormField, Modal, TextInput, Footer, Button, Variants, ModalAction } from "@sede-enterprise/shell-ds-react-framework";
import { IExchangeConfig, BidProductTypeEnum, ExchangeTypeEnum } from "../../services";
import styled from "styled-components";
import { useAppDispatch } from "../../store";
import { useState } from "react";
import { PostExchangeConfigAction } from "../../store/ExchangeConfig/ActionCreator";
import { isString } from "highcharts";
import DropDownList, { IDictionary } from "../../components/DropDownList/DropDownList";

const ColumnDiv = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-evenly;
    gap: 10px;
`;

const CheckboxStyled = styled(Checkbox)`
margin-top: 24px;
 `;

interface IExchangeConfigAddNewEntityProps {
  onCancel: () => void;
}
export const AddExchangeConfigEntity = ({ onCancel }: IExchangeConfigAddNewEntityProps) => {
  const dispatch = useAppDispatch();
  const open = true;
  const convertExchangeIdToName = (exchangeId: string) => {
    return (exchangeId === "1") ? ExchangeTypeEnum.Jao : ExchangeTypeEnum.Empire;
  }
  const convertExchangeNameToId = (exchangename: string) => {
    return (exchangename === ExchangeTypeEnum.Jao) ? "1" : "2";
  }
  const [corridorCode, setCorridorCode] = useState<string>("NA");
  const [exchangeId, setExchangeId] = useState<string>("1");
  const [inAreaEicCode, setInAreaEicCode] = useState<string>("NA");
  const [outAreaEicCode, setOutAreaEicCode] = useState<string>("NA");
  const [productType, setProductType] = useState<string>("NA");
  const [key, setKey] = useState<string>("");
  const [keyValue, setKeyValue] = useState<string>("");
  const [isActive, setIsActive] = useState<boolean>(false);

  const changeCorridorCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCorridorCode(e.target.value);
  }; 
  const changeKeyValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setKeyValue(e.target.value);
  };
  const changeKey = (e: React.ChangeEvent<HTMLInputElement>) => {
    setKey(e.target.value);
  };
  const changeInAreaEicCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInAreaEicCode(e.target.value);
  };
  const changeOutAreaEicCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOutAreaEicCode(e.target.value);
  };
  
  const changeExchangeId = (exchangeId: string) => {
    setExchangeId(convertExchangeNameToId(exchangeId));
  };
  const isString = (str: string) => !(!str?.length);
  const validate = () => {
    if (!isString(keyValue) || !isString(key)) {
      return false;
    }
    return true;
  };
  const onConfirm = () => {
    if (validate()) {
      dispatch(CreateOrUpdateExchangeConfig());
      onCancel();
    }
  };

  const CreateOrUpdateExchangeConfig = () => {
    return PostExchangeConfigAction({
      id: 0,
      corridorCode: corridorCode,     
      exchangeId: Number(exchangeId),
      createdDateTime: new Date(),
      updatedDateTime: new Date(),
      outAreaEicCode: outAreaEicCode,
      inAreaEicCode: inAreaEicCode,
      productType: productType,
      isActive: isActive,
      key: key,
      value: keyValue
      } as IExchangeConfig)
  }
  const productTypes = () => {
    let dictionary: IDictionary[] = [];
    let products = Object.keys(BidProductTypeEnum).map((x) => {
      return {
        key: x,
        value: x,
      } as IDictionary;
    });
    return products || dictionary;
  }
  const [products] = useState<IDictionary[]>(productTypes());

  const exchangeNames = () => {
    let dictionary: IDictionary[] = [];
    let exchanges = Object.values(ExchangeTypeEnum).map((x) => {
      return {
        key: x,
        value: x,
      } as IDictionary;
    });
    return exchanges || dictionary;
  }
  const [exchanges] = useState<IDictionary[]>(exchangeNames());

  const actions: ModalAction[] = [{
    label: 'Cancel',
    action: () => {
      onCancel();
    },
    props: {
      variant: Variants.Outlined
    }
  }, {
    label: 'Save',
    action: () => {
      onConfirm();
    }
  }];

  return (
    <div>
      <Modal title={`ADD NEW - Exchange Configs`} open={open} onClose={onCancel} actions={actions}>
        <form>
          <ColumnDiv>
            <FormField id="exchangeIdFormField" label="Exchange">
            <DropDownList
              content={exchanges}
              placeholder="Select Exchange"
              value={convertExchangeIdToName(exchangeId)}
              allowClear={false}
              onSelect={changeExchangeId}
              disabled={false}
              width="100%"
              ></DropDownList>
            </FormField>
            <FormField id="isActive">
              <CheckboxStyled label="Active" onChange={() => setIsActive(!isActive)} checked={isActive}  />
            </FormField>
          </ColumnDiv>
         <ColumnDiv>
            <FormField id="changeKey" label="Key"
              description={!isString(key) ? "Please enter a valid Key" : ""}>
              <TextInput
                aria-labelledby="input"
                id="changeKey"
                onChange={changeKey}
                value={key}
                autoComplete="off"
                />
            </FormField>
            <FormField
              id="changeKeyValue"
              label="Value"
              description={!isString(keyValue) ? "Please enter a valid value" : ""}>
              <TextInput
                aria-labelledby="input"
                id="changeKeyValue"
                onChange={changeKeyValue}
                value={keyValue}
                autoComplete="off"/>
            </FormField>
          </ColumnDiv>
         <ColumnDiv>
            <FormField
              id="corridorCode"
              label="Corridor Code">
              <TextInput
                aria-labelledby="input"
                id="corridorCode"
                value={corridorCode}
                onChange={changeCorridorCode}
                autoComplete="off" />
            </FormField>
            <FormField id="productTypeFormField" label="Product Type">
              <DropDownList
                content={products}
                placeholder="Select Product"
                value={productType}
                allowClear={false}
                onSelect={(e: any) => setProductType(e)}
                disabled={false}
                width="100%"
              ></DropDownList>
            </FormField>          
          </ColumnDiv>
         <ColumnDiv>
            <FormField id="inAreaEicCode" label="In Area Eic Code">
              <TextInput
                aria-labelledby="input"
                id="inAreaEicCode"
                onChange={changeInAreaEicCode}
                value={inAreaEicCode}
                autoComplete="off" />
            </FormField>
            <FormField id="outAreaEicCode" label="Out Area Eic Code">
            <TextInput
                aria-labelledby="input"
                id="outAreaEicCode"
                onChange={changeOutAreaEicCode}
                value={outAreaEicCode}
                autoComplete="off" />
          </FormField>
          </ColumnDiv>
       </form>
      </Modal>
   </div >
  )
}
export default AddExchangeConfigEntity;